// extracted by mini-css-extract-plugin
export default {"backdrop":"qWmZYQ_","_dialog_overlay":"cklt3TN","fixed":"X3HNFOs","dialog":"ayyLRyb","main":"EJw2EDe"};